export default __webpack_public_path__ + "static/case4-a2204c9b098b4fba20964bbec4513ea3.png";